import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { SpineAnimation } from "./SpineAnimation";

export type LayerName = "none" | "bg" | "midBG" | "defaultBack" | "default" | "wall" | "player" | "foreground";

export class GameLayers {

	layers: Map<LayerName, Phaser.GameObjects.Container>;
	spineContainers: Map<LayerName, SpineContainer>;

	constructor(scene: GameScene) {
		this.layers = new Map<LayerName, Phaser.GameObjects.Container>();
		this.spineContainers = new Map<LayerName, SpineContainer>();

		const layers: LayerName[] = ["bg", "midBG", "defaultBack", "default", "wall", "player", "foreground"];
		for (const key of layers) {
			const layer = scene.add.container();
			this.layers.set(key, layer);
			scene.gameContainer.add(layer);

			const spineContainer = scene.add.spineContainer(0, 0);
			scene.gameContainer.add(spineContainer);
			this.spineContainers.set(key, spineContainer);
		}
	}

	get(layer: LayerName): Phaser.GameObjects.Container {
		return this.layers.get(layer);
	}

	getSpineContainer(layer: LayerName): SpineContainer {
		return this.spineContainers.get(layer);
	}

	addObject(obj: GameObject, layer: LayerName): void {
		const container = this.get(layer);
		if (container) container.add(obj);
		const anim = obj.getComponent(SpineAnimation);
		if (anim) this.batchSpine(anim, layer);
	}

	batchSpine(anim: SpineAnimation, layer: LayerName): void {
		const container = this.getSpineContainer(layer);

		// search for the last item in the container with a matching key,
		// so we can keep all objects with the same key together.
		let insertAfterIndex = container.list.length - 1;
		for (let i = container.list.length - 1; i >= 0; i--) {
			const obj2 = container.list[i];
			if (obj2.getData("spineKey") == anim.key) {
				insertAfterIndex = i;
				break;
			}
		}

		container.addAt(anim.spine, insertAfterIndex + 1);
	}
}